import Accordion from "./Accordion";
import visual1 from "../../Media/Myanmar/Visual 1.png";
import visual2 from "../../Media/Myanmar/Visual 2.png";




const ChartsSection = (props) => {
  
const chartText = {
  caucasus: [
    {
      title:
        "Violence intensified along the Armenia-Azerbaijan border in September 2022",
      body: visual1,
    },
    {
      title:
        "Demonstrations were increasingly deadly in Central Asia in 2022",
      body: visual2,
    },
  ],
  colombia: [
    {
      title:
        "Cauca, Norte de Santander, and Antioquia remained the centers of conflict in 2022",
      body: visual1,
    },
    {
      title:
        "Civilian targeting drove increasingly deadly violence in 2022",
      body: visual2,
    },
  ],
  drc: [
    {
      title:
        "M23 became one of the most active non-state armed groups in 2022",
      body: visual1,
    },
    {
      title:
        "Violence against civilians by non-state armed groups continued at a heightened level in 2022",
      body: visual2,
    },
  ],
  haiti: [
    {
      title:
        "Gang-related violence increasingly drove fatalities in 2022 in Haiti",
      body: visual1,
    },
    {
      title:
        "Gang fragmentation increased in Haiti in 2022",
      body: visual2,
    },
  ],
  kurdistan: [
    {
      title:
        "Political Violence Between Turkish Forces and Kurdish Groups (2018-2022)",
      body: visual1,
    },
    {
      title:
        "Political Violence in Iraq Involving Iranian Forces (2018-2022)",
      body: visual2,
    },
  ],
  myanmar: [
    {
      title:
        "State forces increased targeting of civilians with explosive and remote violence in 2022",
      body: visual1,
    },
    {
      title:
        "More than 1 out of every 4 incidents of violence targeting civilians in 2022 took place in Myanmar",
      body: visual2,
    },
  ],
  nigeria: [
    {
      title:
        "Violence Targeting Civilians by Actor Type (2018-2022)",
      body: visual1,
    },
    {
      title:
        "Reported Fatalities from Violence Targeting Civilians by Region (2022)",
      body: visual2,
    },
  ],
  sahel: [
    {
      title:
        "Cauca, Norte de Santander, and Antioquia remain the centers of conflict in 2022",
      body: visual1,
    },
    {
      title:
        "Civilian targeting drives increasingly deadly violence: 2018-2022",
      body: visual2,
    },
  ],
  ukraine: [
    {
      title:
        "Air and drone strikes in Ukraine peaked between July and September 2022",
      body: visual1,
    },
    {
      title:
        "Shelling, artillery, and missile attacks remained a constant threat to civilians throughout 2022",
      body: visual2,
    },
  ],
  yemen: [
    {
      title:
        "Reported Fatalities from Political Violence in Yemen (2022)",
      body: visual1,
    },
    {
      title:
        "Houthi Control of Marib Governate (2020-2022)",
      body: visual2,
    },
  ],
};
const dataForAccordion = chartText[props.focusCountry];
  return (
    <div
      style={{
        width: "100%",
        height: props.height,
        boxSizing: "border-box",
      }}
    >
      <Accordion dataForAccordion={dataForAccordion} height={props.height} focusCountry={props.focusCountry} />
    </div>
  );
};

export default ChartsSection;
